import { store } from '../../../../app/store';
import { extractErrorMessage } from '../../../../utils/errorUtils';
import { financeEmailHistoryActionApi } from '../../api/financeEmailHistoryActionApi';
import { isInboundFinanceEmailHistoryId } from '../../utils/financeEmailHistoryId';
import type { CommandHandler } from '../types';

export const addFinanceEmailSenderToSpamListCommandHandler: CommandHandler = async (
  _command,
  context
) => {
  const historyId = String(context.entityId ?? context.parentId ?? '').trim();
  if (!isInboundFinanceEmailHistoryId(historyId)) {
    return {
      success: false,
      error: 'Add sender to spam list is only available for inbound finance emails.',
    };
  }

  const direction = String(context.entityData?.Direction ?? context.entityData?.direction ?? '')
    .trim()
    .toLowerCase();
  if (direction && direction !== 'inbound') {
    return {
      success: false,
      error: 'Add sender to spam list is only available for inbound finance emails.',
    };
  }

  const fromAddress = String(
    context.entityData?.FromAddress ?? context.entityData?.fromAddress ?? ''
  ).trim();
  const confirmMessage = fromAddress
    ? `Add "${fromAddress}" to the auto-spam list and move this email to spam?`
    : 'Add this sender to the auto-spam list and move this email to spam?';

  if (context.requestConfirmation) {
    const confirmed = await context.requestConfirmation(confirmMessage);
    if (!confirmed) {
      return { success: false };
    }
  }

  try {
    const message = await store
      .dispatch(
        financeEmailHistoryActionApi.endpoints.addFinanceEmailSenderToSpamList.initiate(historyId)
      )
      .unwrap();

    return {
      success: true,
      shouldRefresh: true,
      message: message || 'Sender added to the spam list.',
    };
  } catch (error) {
    return {
      success: false,
      error: extractErrorMessage(error, 'Failed to add sender to spam list.'),
    };
  }
};
